import React from "react";
import { FILTER_FIELDS, MAX_FETCH_LIMIT } from "./utils";

const RedisLogFilters = ({filters,loading,actionLoading,onFilterChange,onApplyFilters,onClearFilters,}) => {
  return (
    <form onSubmit={onApplyFilters}>
      <div className="row g-2 align-items-end">
        {FILTER_FIELDS.map((field) => (
          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6" key={field.name}>
            <label className="form-label" htmlFor={`redis-log-${field.name}`}>
              {field.label}
            </label>
            <input
              id={`redis-log-${field.name}`}
              name={field.name}
              type="text"
              className="form-control"
              value={filters[field.name] || ""}
              onChange={onFilterChange}
              placeholder={field.placeholder}
            />
          </div>
        ))}
        <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6">
          <label className="form-label" htmlFor="redis-log-limit">
            Limit
          </label>
          <input
            id="redis-log-limit"
            name="limit"
            type="number"
            className="form-control"
            min="1"
            max={MAX_FETCH_LIMIT}
            value={filters.limit || ""}
            onChange={onFilterChange}
          />
        </div>
        <div className="col-xl-4 col-lg-6 col-md-8">
          <div className="d-flex gap-2 flex-wrap">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || actionLoading}
            >
              <i className="bi bi-funnel me-1" aria-hidden="true"></i>
              Apply filters
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClearFilters}
              disabled={loading || actionLoading}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default RedisLogFilters;
